export type ToolExecuteHandler = () => void;

export type WaitQueueCallback = (response: any) => void;
